export default __webpack_public_path__ + "static/media/char-obiwan.c23f91b2.jpg";